import { titleMap } from '~/constants/title-map'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('page:finish', () => {
    const route = useRoute()
    const path = route.path

    const propMatch = path.match(/^\/property-manager\/(prop-\d{3}(?:-\d{2})?)$/);
    const admMatch = path.match(/^\/admin\/(adm-\d{3}(?:-\d{2})?)$/);

    const key = propMatch?.[1] || admMatch?.[1];
    const titleKey = key && titleMap[key];
    useHead({
      title: titleKey ? globalThis.$t(titleKey) : globalThis.$t('default.title'),
    })
  })
})
